export default {
    'homepage':{
      'titolo':'Liberati!',
      'sottotitolo':'Conosci nuove persone',
      'accedi':'Accedi',
      'registrati':'Registrati',
      'gia_registrato':'Se sei già registrato al servizio, fai login:',
      'non_registrato':'Se non sei ancora registrato, registrati subito ed inizia ad incontrare nuove persone!',
      'perche':'Perché scegliere',
      'trova':'Trova il single che fa per te',
      'sicurezza':'La sicurezza per $servizio$ è una priorità',
      'aumenta_visibilita':'Profili completi possono favorire la visibilità',
      'cerca_persona_adatta':'Possibilità di conoscere nuove persone',
      'desc_sicurezza':'La piattaforma adotta misure per offrire un ambiente rispettoso e affidabile a tutti gli iscritti. I contenuti caricati vengono verificati secondo linee guida interne e sono applicate misure tecniche e organizzative per la protezione dei dati personali.',
      'desc_visibilita':'La creazione di un profilo con foto e informazioni consente di presentarsi in modo più chiaro alla community. Profili più completi possono ricevere più interazioni sulla piattaforma.',
      'desc_persona_adatta':'La piattaforma consente di esplorare profili, avviare chat e creare nuove amicizie online. Filtri di ricerca e suggerimenti personalizzati aiutano a visualizzare persone in linea con le preferenze indicate.',
      'sezione_coppie':'Coppie che si sono conosciute su $servizio$'
    },
    'navbar_mobileNew': {
      'cerca': 'Cerca',
      'messaggi': 'Messaggi',
      'profilo':'Profilo',
      'vip':'VIP',
      'registrati':'Registrati',
      'incentive_menu':'Aggiungi crediti messaggio',
      'messaggi_restanti':'Crediti',
      'rimanenti':'rimanenti',
      'logout':'Esci',
      'attiva_notifiche':'Telegram',
      'crediti':'Crediti',
      'titolo_cerca':'CERCA',
      'titolo_match':'MATCH',
      'titolo_messaggi':'MESSAGGI',
      'titolo_notifiche':'NOTIFICHE',
      'titolo_avvisi':'AVVISI',
      'titolo_profilo':'PROFILO',
      'titolo_rateplan':'AUMENTA CREDITI',
      'profilo_angel':'PROFILO UTENTE',
      'diventa_premium':'DIVENTA PREMIUM',
    },
    'chat_content': {
      'disponibile': 'disponibile',
      'inserire_numero':'Per inserire un numero devi essere un utente verificato come <strong>$angel$</strong>',
      'registrarti':'devi scegliere un piano di iscrizione',
      'scrivi_un_messaggio':'Scrivi un messaggio...',
      'rompi_il_ghiaccio':'Rompi il ghiaccio!',
      'prova_con':'Prova con uno di questi messaggi che tutti usano. Sceglilo e poi invialo',
      'messaggio1':'Ciao, vorrei vedere le tue foto private',
      'messaggio2':'Come va? Ti va di parlare un po\'?',
      'messaggio3':'Ho visto il tuo profilo e vorrei conoscerti meglio',
      'hook_blurred':'Leggi il messaggio',
      'non_essere_timido':'$angel$ è disponibile.<br>Inviale un messaggio!',
      'sta_scrivendo':'sta scrivendo..',
      'ha_visitato':'<i class="far fa-eye"></i> ha visitato il tuo profilo',
      'elimina_chat':'Elimina chat',
      'sei_sicuro':'Sei sicuro?',
      'si':'Sì',
      'no':'No'
    }, 
    'profilo': {
      'cambia_foto': 'Cambia la foto',
      'username': 'Username',
      'cambia': 'cambia',
      'cognome': 'Cognome',
      'eta': 'Età',
      'email': 'Email',
      'sono': 'Sesso',
      'inserisci_numero': 'Inserisci il tuo numero di telefono',
      'inserisci_username': 'Inserisci il tuo username',
      'inserisci_email': 'Inserisci la tua email',
      'inserisci_citta': 'Inserisci la tua città',
      'inserisci_eta': 'La tua età',
      'salva': 'Salva modifiche',
      'cerco': 'Cerco',
      'citta': 'Città',
      'uomo':'Uomo',
      'donna':'Donna',
      'scegli':'Scegli..',
      'solo_immagini': 'Sono permesse solo immagini',
      'grandezza_file':'La foto deve essere minore di 10Mb',
      'foto_non_conforme':'Foto rifiutata: viola le norme della piattaforma',
      'foto_chat_non_conforme':'Messaggio non inviato: la foto viola le politiche della piattaforma',
      'mail_esistente':'La mail scelta è già esistente',
      'seleziona_altra_mail':'Seleziona un\'altra mail per aggiornare correttamente il tuo profilo',
      'titolo_ok':'Modifiche effettuate correttamente',
      'testo_ok':'Le modifiche al tuo profilo sono state effettuate in modo corretto',
      'crediti_messaggi':'Crediti:',
      'aggiungi':'Aggiungi',
      'disiscrizione':'Disiscriviti',
      'header_disiscrizione':'Chiudere il servizio',
      'titolo_disiscrizione':'Vuoi procedere con la disiscrizione?',
      'descrizione_disiscrizione':'Perderai tutte le possibilità di chattare con nuove ragazze e di avere nuove piccanti avventure',
      'disiscrizione_ok':'Disiscrizione avvenuta con successo',
      'disiscrizione_ko':'C\'è stato un errore in fase di disiscrizione, contatta il customer care',
      'descrizione':'Descrizione',
      'cosa_cerco':'Cosa cerchi',
      'cambia_foto':'Cambia foto',
      'regione':'Scegli la tua regione',
      'utente_free':'Sei un utente FREE ed hai a disposizione $icebreacker$ messaggi per rompere il ghiaccio e $messaggi$ messaggi di risposta. Diventa un utente PREMIUM per ottenere messaggi in quantità illimitata.',
      'diventa_premium':'Diventa PREMIUM ora',
      'scegli_citta':'Scegli la tua città',
      'impostazioni_profilo':'Impostazioni profilo',
      'disattiva_profilo':'Disattiva profilo',
      'disattiva_profilo_ok':'Il tuo profilo è stato disattivato e non sarà più visibile ad altri utenti. Per riattivarlo contatta il customer care',
      'torna_home': 'Esci',
      'sei_sicuro_disattiva_profilo':'Sei sicuro di voler disattivare il tuo profilo?',
      'spiegazione-disattiva_profilo':'<div class="testo_popup_disattivazione">Disattivando il tuo profilo non potrai più:<ul><li>accedere al servizio</li><li>non sarai più visibile agli altri utenti</li><li>non potrai più usare i tuoi crediti</li></ul>. Per riattivare il tuo profilo dovrai contattare il customer care - <span style="font-weight:bold">Vuoi procedere?</span></div>',
      'si': 'Si',
      'no': 'No',
      'ricevute_acquisti':'Ricevute acquisti',
      'gestione_notifiche':'Gestione notifiche',
      'telegram':'Telegram',
      'notifiche_push':'Notifiche push',
      'email_tracking': 'Pixel tracking',
      'stato_profilo':'Stato profilo',
      'prossimo_addebito':'Prossimo addebito',
      'supporto':'Supporto',
    },
    'user': {
      'chat': 'Invia messaggio',
      'mi_piace': 'Mi piace',
      'anni': 'Anni',
      'posizione': 'Posizione',
      'capelli': 'Capelli',
      'altezza':'Altezza',
      'peso': 'Peso',
      'descrizione': 'Descrizione',
      'cerca': 'Cerco',
      'vicino_a_te':'Vicino a te',
      'messaggi_rimanenti':'Messaggi rimanenti',
      'incentive':'Registrati per ricevere altri messaggi',
      'persona_interessata':'Questa persona potrebbe essere interessata a te',
      'registrati_adesso':'Registrati adesso',
      'messaggi_illimitati':'in questo modo potrai mandarle messaggi illimitati ed organizzare un incontro',
      'blond':'Biondi',
      'brown':'Marroni',
      'red':'Rossi',
      'darkblond':'Biondo scuro',
      'black':'Neri',
      'colored':'Tinti',
      'mi_piace_inviato':'Abbiamo inviato il tuo "Mi Piace" ❤️',
      'scrivile_in_privato':'Scrivi un messaggio privato',
      'uomo': 'Uomo',
      'donna': 'Donna',
      'segnala_blocca': 'Segnala o blocca',
      'utente_bloccato': '🚫 Utente bloccato e segnalato, non potrà più contattarti',
    },
    'signup': {
      'registrazione': 'Registrazione',
      'immediata': 'Immediato',
      'incontri_segreti': 'Incontri segreti e discreti...',
      'trova_ragazze': 'Incontra nuove donne che attraverso un incontro discreto desiderano scappare per qualche ora..',
      'scegli_una_password': 'Scegli una password',
      'continua': 'CONTINUA',
     },
    'popupHook': {
      'utente_registrato': 'è un utente VIP!',
      'incentive_1': 'Per poter inviare altri messaggi e parlare con le altre donne disponibili, registrati gratuitamente.',
      'incentive_2': 'Per vedere il suo numero di cellulare registrati subito.',
      'altri_profili': 'Mostra altri profili',
      'incentive_3': 'Vuoi vedere tutte le altre donne disponibili nella tua zona?',
      'utenti_usano': 'La maggior parte dei nostri utenti usa',
      'si_raccomanda': 'Si raccomanda di registrarsi',
      'cambiar_profilo': 'Gli utenti premium possono cambiare il proprio profilo',
      'per_cambiar_profilo': 'Per cambiare profilo ed aggiungere il contatto di',
      'registrati_adesso': 'Registrati adesso',
      'gia_account': 'Hai gi� un account?',
      'bentornato': 'Bentornato! Inserisci le tue credenziali per accedere al servizio',
      'registrati_home': 'Fai subito amicizia ed incontra persone della tua zona!',
      'accedi_subito':'Accedi subito!',
      'continua':'CONTINUA',
      'blurred_title':'Messaggio non visibile',
      'blurred_body':'ha espresso il desiderio di chattare solo con utenti verificati come lei.',
      'blurred_incentive':'Vuoi leggere la risposta di <strong>$angel$</strong>?',
      'espresso_desiderio': 'ha espresso il desiderio di conoscere SOLO utenti verificati come lei',
      'vuoi_vedere':'Vuoi vedere le sue foto, i suoi dettagli e mandarle messaggi immediatamente?',
      'verifica_ora':'Verifica ora il tuo account',
      'diventa_premium':'Diventa premium',
      'verifica_profilo':'Verifica profilo',
      'messaggio_non_mandato':'Il messaggio non può essere inviato',
      'attiva_pass':'Attiva il tuo <strong>PASS</strong> per mandarlo immediatamente',
      'attiva_lettura':'Vuoi sapere se <strong>$angel$</strong> legge i tuoi messaggi?',
      'ti_piace': 'Ti piace',
      'attiva_generico':'Vuoi continuare a mandare LIKE?',
      'mi_piace_inviato':'Abbiamo inviato il tuo "Mi Piace" ❤️',
      'donne_regione':'Gli utenti VIP possono vedere profili di altre regioni',
      'sottotitolo_regione':'Per vedere tutte le donne online anche di un\'altra regione si raccomanda di diventare VIP',
      'messaggio_sospeso':'Messaggio in sospeso',
      'attiva_pass_senza_limiti':'Vuoi continuare a mandare messaggi a <strong>$angel$</strong>?',
      'per_scoprire':'Per scoprire tutto di <strong>$angel$</strong> vuole che verifichi il tuo account adesso',
      'la_vuoi_conoscere':'VUOI CONOSCERE ',
      'imposta_regione':'Seleziona una città in cui vuoi trovare donne per il tuo prossimo appuntamento',
      'quasi_terminato':'Hai quasi terminato!',
      'inizio_divertimento':'Che l\'avventura abbia inizio! 🎉',
      'inserisci_mail_e_pws':'Inserisci la tua E-mail una Password efficace',
      'ti_invieremo':'Ti invieremo una mail che dovrai aprire e cliccare sul link per verificare <strong>anche tu</strong> il tuo account ed interagire con gli altri utenti',
      'se_non_trovi':'⚠️ Se non trovi la mail guarda nella tua casella di SPAM o POSTA INDESIDERATA. ⚠️',
      'non_lasciare_sospeso':'Il messaggio per <strong>$angel$</strong> non può essere inviato!',
      'altri_uomini':'<i>Altri uomini online ora potrebbero scriverle.</i>',
      'utente_disabilitato':'Il tuo account è disabilitato. Contatta il customer care',
     },
     'popupNotifica':{
       'hai_ricevuto_messaggio':'Hai ricevuto un messaggio',
       'da':'da',
       'rispondi':'Rispondi',
       'profilo':'Profilo',
       'hai_ricevuto_like':'ti ha mandato un LIKE!',
       'risposta_a_like':'ha risposto al tuo LIKE! Mandale subito un messaggio',
       'ha_guardato_tuo_profilo':'ha appena guardato il tuo profilo',
       'avvisami_risposta':'Avvisami quando risponde',
       'avvisami_novita':'Avvisami quando ci sono novità',
       'visualizza':'Guarda il profilo'
     },
     'popupInfo':{
      'anni': 'Anni',
     },
     'popupGenerico':{
      'chiudi': 'Chiudi',
      'cambia_carta':'Cambia Carta',
      'bentornato':'Bentornato, ci sei mancato!',
      'regalo_messaggi':'Per questo motivo ti abbiamo regalato dei crediti. 🎁 Chatta subito con chi vuoi!',
     },
     'popupFoto':{
      'carica_foto': 'Inserisci una tua foto <br /> per completare il Profilo',
      'incentivo':'Gli utenti con una foto, <br/>ricevono <strong>7 volte più messaggi!</strong>',
      'lo_faro_dopo':'Lo farò dopo'
     },
     'signupForm':{
        'caricando':'Caricando...',
        'scegli_una_password':'Scegli una password',
        'registrati_gratis':'Registrati ora gratis',
        'accedi':'Accedi',
        'gia_registrato':'Già registrato?',
        'iscriviti':'Non ancora registrato?',
        'password':'Password',
        'password_dimenticata':'Password dimenticata?',
        'indietro':'Torna al login',
        'invia':'Invia',
        'introduci_mail_reset_password':'Introduci la tua mail per avviare il processo di reset della password',
        'email_inviata':'Ti è stato inviato un link al tuo indirizzo email per reimpostare la password.',
        'utente_inesistente':'L\'indirizzo inserito non esiste',
        'mail_password_errati':'La mail o la password sono errati',
        'sono': 'Sono',
        'cerco':'Cerco',
        'citta':'Città',
        'email':'Inserisci la tua email',
        'suggerimento_citta':'Inserire almeno tre caratteri e poi scegli dalla lista',
        'errore_citta':'Compila il campo regione',
        'errore_email':'Completa il campo Email',
        'errore_password':'Completa il campo password',
        'regione':'Scegli la tua regione',
        'eta':'Iserisci la tua età',
        'errore_sono':'Completa il campo sono',
        'errore_cerco':'Completa il campo cerco',
        'errore_terms':'Per procedere devi accettare le condizioni generali del servizio',
        'accetto_clausole':'Accetto espressamente le clausole vessatorie elencate all\'art.14 delle <a href="$terms$">Condizioni Generali</a> del servizio',
        'acconsento_trattamento':'Acconsento al trattamento dei miei dati personali per finalità promozionali come indicato nell\'<a href="$privacy$">Informativa Privacy</a>',
        'acconsento_comunicazione':'Acconsento alla comunicazione dei miei dati personali a soggetti terzi per loro finalità di marketing, come indicato nell\'<a href="$privacy$">Informativa Privacy</a>',
        'acconsento_trattamento_pixel':'Acconsento al trattamento dei miei dati personali per finalità promozionali come indicato nell\'<a href="$privacy$">Informativa Privacy</a>. Le comunicazioni email potrebbero contenere pixel di tracciamento.',
        'acconsento_comunicazione_pixel':'Acconsento alla comunicazione dei miei dati personali a soggetti terzi per loro finalità di marketing, come indicato nell\'<a href="$privacy$">Informativa Privacy</a>. Le comunicazioni email potrebbero contenere pixel di tracciamento.',
        'dichiaro_maggiorenne':'Confermo di essere maggiorenne',
        'cliccando_accetti':'Cliccando su Registrati dichiari di aver letto ed accettato l\' <a href="$privacy$">Informativa Privacy</a> e le <a href="$terms$">Condizioni Generali</a> del servizio',
        'orientamenti_sessuali':'Dò il mio esplicito consenso al trattamento dei dati in grado di rivelare le mie preferenze e orientamenti sessuali, come indicato nell\'<a href="$privacy$">Informativa Privacy</a>'

     },
     'photoItem':{
      'bottone_chat':'Chatta',
      'bottone_like':'Mi Piace',
      'bottone_profilo':'Profilo',
      'registrati_gratis':'Registrati ora gratis',
      'anni':'anni'
    },
    'create_list':{
      'hai_ricevuto_like':'Hai ricevuto un like',
      'hai_ricevuto_visita':'Ha visitato il tuo profilo',
      'ha_rispost_like':'Ha risposto al tuo like!',
      'non_letto':'NON LETTO',
      'nessuna_notifica':"Non hai ancora ricevuto nessuna notifica",
      'nessun_messaggio':'Non hai ancora ricevuto nessun messaggio, aggiungi una foto profilo ed utilizza la pagina Match per mettere qualche Like',
      'mi_piace':'Mi Piace',
      'elimina_chat':'Elimina chat',
      'sei_sicuro':'Sei sicuro?',
      'si':'Sì',
      'no':'No'
    },
     'navbar_desktop':{
      'cerca': 'Cerca',
      'messaggi': 'Messaggi',
      'profilo':'Profilo',
      'registrati':'Registrati',
      'vip':'VIP',
      'incentive_menu':'Registrati per ricevere altri messaggi',
      'messaggi_restanti':'Crediti',
      'rimanenti':'rimanenti',
      'logout':'Esci',
      'attiva_notifiche':'Attiva Notifiche',
      'notifiche':'Notifiche',
      'match':'Match',
    },
    'creditCardForm':{
      'numero_carta': 'Numero di carta',
      'nome_intestatario':'Nome intestatario',
      'cognome_intestatario':'Cognome intestatario',
      'scadenza':'Scadenza',
      'CVC':'CVC',
      'continua':'CONTINUA',
      'tasto_riprova':"RIPROVA",
      'carta':'Carta di credito',
      'nome':'Nome',
      'cognome':'Cognome', 
      'disclaimer_fluxid0000':'Facendo click su continua accetti i <a href="$terms$"> Termini e Condizioni</a> e la <a href="$privacy$"> Politica sulla Privacy </a>',
      'disclaimer':'Facendo click su continua accetti i <a> Termini e Condizioni</a> e la <a> Politica sulla Privacy </a>',
      'pagamento_sicuro':'Pagamento Sicuro',
      'descriptor':'Ci preoccupiamo della tua vita privata e rispettiamo la tua privacy. L\'addebito effettuato sulla tua carta di credito verrà elencato sotto la voce $descriptor$ sul tuo estratto conto',
      'errore':'Errore',
      'qualcosa_storto':'Qualcosa è andato storto',
      'cambia_carta':'Prova subito con un\'altra carta per continuare a Chattare o cambia metodo di pagamento ',
      'cvv_errato':'Il CVV/CVC non è corretto. Correggi il CVV/CVC oppure cambia metodo di pagamento per continuare a Chattare.',
      'fondi_insufficenti':'Sembra che la tua carta non abbia fondi o abbia raggiunto il limite di spesa. Ti invitiamo a controllare o a cambiare metodo di pagamento',
      'persa_rubata':'Carta non utilizzabile. Prova subito un\'altra carta o cambia metodo di pagamento per continuare a Chattare',
      'scaduta':'La carta che hai utilizzato è scaduta. Aggiorna la carta o cambia metodo di pagamento per continuare a Chattare',
      'gia_processata':'Questa carta è già stata rifiutata. Si prega di provare una nuova carta.',
      'numero_carta_non_valido':'Controlla che i dati della tua carta siano corretti per continuare a Chattare',
      'riprova':'Ulteriore tentativo richiesto. Nei prossimi passaggi verrai rimandato al sito della banca per verificare la tua identità. Potrai ricevere un SMS o una notifica sull\'app della tua banca.',
      'blacklisted':'La tua carta è nella lista nera',
      'generico':'Carta rifiutata. Prova subito con un\'altra carta per continuare a Chattare o cambia metodo di pagamento',
      '3ds':'Ulteriore tentativo richiesto',
      'verifica_fallita':'La verifica richiesta dalla tua banca per confermare la tua identità non è andata a buon fine',
      'success':'Grazie, il pagamento è andato a buon fine. Continua a chattare ed in bocca al lupo per il tuo prossimo appuntamento',
      'consiglio_generico':'Prova subito con un\'altra carta per continuare a <span className="special_bold">CHATTARE</span>',
      'consiglio_insufficent_fund':'La tua carta al momento non è utilizzabile per insufficienza di fondi, cambia carta per continuare a chattare',
      'consiglio_3ds':'Nei prossimi passaggi verrai rediretto al sito della tua banca per verificare la tua identità. Conferma la notifica che arriverà dalla tua banca',
      'disclaimer_verifica_eta':'Facendo clic su CONTINUA, accetti le nostre Condizioni d\'uso e l\'Informativa sulla privacy, e potrebbe essere addebitata una tassa di verifica di 0,01€.',
      'descrizione_pending':'Sembra che la tua banca ci stia mettendo più tempo del previsto. Continua a navigare, ti daremo i crediti appena l\'operazione sarà approvata',
      'titolo_cvv':'Correggi CVV/CVC',
      'titolo_fondi_insufficenti':'Carta scarica?',
      'titolo_persa_rubata':'Carta non utilizzabile',
      'titolo_generico':'Carta rifiutata',
      'titolo_pending':'L\'operazione è ancora in corso',
      'titolo_success':'Pagamento accettato',
      'titolo_verifica_fallita':'Errore Acquisto',
      'titolo_riprova':'Ulteriore tentativo richiesto',
      'cambia_metodo_pagamento':'Questo metodo di pagamento è stato bloccato per un numero eccessivo di tentativi falliti. Per favore, prova con un altro metodo di pagamento.',
      'open':'Stiamo attendendo la tua banca per confermare il pagamento. I crediti ti saranno accreditati in caso di esito positivo. Solitamente squesto richiede qualche minuto',
      'titolo_open':'Pagamento in attesa',
      'titolo_canceled':'Pagamento annullato',
      'descrizione_canceled':'Hai annullato il pagamento. Riprova con per continuare a chattare',
      'titolo_problemi_api':'Transazione non riuscita',
      'descrizione_problemi_api':'Sembra che ci siano dei problemi con questo metodo di pagamento. Prova con un altro metodo',
      'pagamento_in_corso':'Pagamento in corso...',
      'attendi_un_minuto':'Un pagamento è già in corso, attendi un minuto prima di fare altri acquisti.',
      'waiting':'Stiamo attendendo la conferma del pagamento da parte della tua banca. Attendi qualche istante per favore',
      'titolo_waiting':'Ancora un istante',
      'titolo_pacchettone':'Congratulazioni!',
      'descrizione_pacchettone':'Vogliamo premiare il tuo impegno<br>con una <strong>sorpresa speciale</strong> per te!',
      'prendine_un_altro':'Prendine un altro a metà prezzo!',
      'disclaimer_opale': 'Prova gratuita del servizio di coaching seduzione online.<br> La prova di 10 giorni ti permette di parlare ogni giorno con i coach, ricevere consigli personalizzati e accedere ad articoli esclusivi.Al termine del periodo di prova, il servizio si rinnova automaticamente a 19,90€ ogni 14 giorni, fino alla disdetta.'

    },
    'payment_page':{
      'pagamento_sicuro':'Pagamento Sicuro',
      'dati_protetti':'Dati carta protetti con cifratura SSL',
      'non_paghi_nulla':'N.B Per verificare il tuo account non pagherai nulla. Ma l\'inserimento di una carta attiva è l\'unico modo per dimostrare di essere un utente reale come tutti gli utenti verificati',
      'verifica_profilo':'Verifica profilo',
      'stai_acquistando':'Stai acquistando',
      'procedura':'La verifica è tramite carta di credito è GRATIS',
      'nessun_addebito':'<strong>€ 0.00 - Senza addebito</strong><br>SOLO ADULTI!',
      'inserisci_e_verifica':'Inserisci la tua carta<br>e verifica di avere più di <strong>18 anni</strong>',
      'nessun_abbonamento':'Questo <strong>NON</strong> è un abbonamento.<br><strong>NON</strong> avrai alcun riaddebito.',
      'scegli_metodo':'Come vuoi proseguire?',
      'attiva_pass':'Attiva il tuo <strong>PASS</strong> per chattare senza limiti',
      'coda_discplaimer':'Nel caso di acquisto con PayPal la vendita del servizio e la transazione sono gestite direttamente da Coda Netherlands Holdings B.V.',
      'garanzia_di_rimborso':'Garanzia di rimborso',
      'garanzia_di_rimborso_text':'Hai diritto al rimborso completo<br/> se non sei soddisfatto',
      'processando_pagamento':'Stiamo processando il tuo pagamento',
    },
    'pianiAbbonamento':{
      'disclaimer':'Scegliendo un pacchetto di crediti accetti i <a href="$terms$"><u>Termini e le condizioni</u></a> e la <a href="$privacy$"><u>Billing Policy</u></a>',
      'disclaimer2':'Se hai scelto il piano PROMO al termine del periodo di prova di 72 ore verrà convertito in un abbonamento mensile al costo di 29,99€ e si rinnoverà ogni mese finché non ne richiederai la cancellazione. <a href="$terms$"><u>Clicca qui</u></a> per informazioni su come disattivare il tuo abbonamento' ,
      'disclaimer3':'Scegliendo un piano crediti accetti i <a href="$terms$"><u>Termini e le condizioni</u></a> e la <a href="$privacy$"><u>Billing Policy</u></a>',
      'disclaimer4': 'Accetto i <a href="$terms$"><u>Termini e le condizioni</u></a> e la <a href="$privacy$"><u>Billing Policy</u></a>',
      'discplaimer5':'Tutti i piani prevedono il rinnovo automatico',
      'errore':'Errore',
      'qualcosa_storto':'Qualcosa è andato storto',
      'header_chatta_senza_limiti':'Il tuo messaggio per <strong>$angel$</strong> non può essere inviato',
      'header_fine_like':'Vuoi inviare LIKE illimitati?',
      'header_messaggio_offuscato':' Vuoi leggere il messaggio di <strong>$angel$</strong>?',
      'header_paginazione':'Vuoi vedere tutte le donne in linea?',
      'header_cambio_regione':'Vuoi cercare le donne in altre regioni?',
      'testo_verifica_eta':'Per garantire la <strong> sicurezza </ strong> dei nostri utenti <strong> dobbiamo verificare che tu </ strong> <br> <strong> sia maggiorenne </ strong>',
      'testo_bottone_verifica_eta':'IO HO 18+ ANNI',
      'aggiungiamo_crediti':'Stiamo aggiungendo i tuoi crediti',
      'altri_uomini':'<i>Altri uomini potrebbero scriverle</i>',
      'vuoi_continuare':'Attiva il tuo <strong>PASS</strong> per mandarlo IMMEDIATAMENTE',
      'redirigendo':'Stiamo reindirizzando alla pagina di pagamento',
      'crediti':'Crediti',
      'approfitta_ora': 'Approfitta ora di <strong>questa offerta</strong><br />per continuare a ricevere vantaggi.',
      'like_illimitati':'❤️ Like illimitati<br />💬 Chatta con chi vuoi',
    },
    'passwordReset':{
      'caricando':'Caricando...',
      'procedura':'Introduci la nuova password nei campi sottostanti',
      'password':'Nuova password',
      'ripeti':'Ripeti password',
      'invia':'Invia',
      'non_corrispondono':'Le due password non corrispondono',
      'passwordCambiata':'Password sostituita con successo. Vai alla pagina di login',
      'token_expired':'La procedura di reset password è stata effettuata. Riprova'
    },
    'errorHandler':{
      'email_esistente':'La tua mail risulta già esistente. Prova a fare login',
      'utente_non_trovato':'Username o password non validi',
      'qualcosa_storto':'Qualcosa è andato storto, riprova',
      'fingerprint':'Risulta che tu sia già registrato con questa mail: $email$, prova a fare login',
      'email_non_valida':'La mail risulta scritta in modo sbagliato. Controlla punteggiatura e spazi',
      'email_vietata':'Questa email non può essere utilizzata. Usane un\'altra',
      'troppi_tentativi':'Hai effettuato troppi tentativi di iscrizione',
      'account_disabilitato':'Il tuo account è stato disabilitato. Contatta il customer care',
      'welcome_gia_inviata':'La mail di benvenuto è già stata inviata a questo indirizzo <strong class="blink">controlla nella cartella <blink>Spam</blink> o <blink>Posta indesiderata</blink></strong>.',
    },
    'logo':{
      'url':'/img/logo_it.png'
    },
    'ok':{
      'congratulazioni':'Congratulazioni!',
      'utente_premium':'Sei diventato un utente premium',
      'bottone_chat':'Vai alle chat',
    },
    'ko':{
      'ops':'Ops!',
      'qualcosa_storto':'Qualcosa è andato storto',
      'bottone_indietro':'Riprova',
    },
    'searchFilters':{
      'titolo_popup':'Scrivi e poi seleziona la città nella quale vuoi vedere donne disponibili',
      'seleziona':'Seleziona',
      'seleziona_regione':'Filtri di ricerca'
    },
    'footer':{
      'faq':'FAQ',
      'termini':'Termini e condizioni',
      'privacy':'Privacy Policy',
      'cookie':'Cookie policy',
      'contact_us':'Contattaci',
    },
    'chats':{
      'nessun_messaggio':'Non hai ancora nessun messaggio'
    },
    'contactUs':{
      'contattaci':'Contattaci',
      'per_ricevere':'Per ricevere assistenza diretta contattaci utilizzando l\'apposito form nella presente pagina oppure ai seguenti recapiti',
      'caricando':'Caricando...',
      'grazie':'Grazie, il tuo messaggio è stato preso in carico'
    },
    'landingAutologin':{
      'titolone': 'IMPORTANTE',
      'testo':'<strong>$angel$</strong> ti sta cercando. Ricordati che lei come altri utenti di questo sito sono alla ricerca di divertimento non di una relazione. Molte sono sposate e scontente, altre madri single. Vivono tutte in $regione$ se conosci una o più di loro ti chiediamo di mantenere segreta la loro identità all\'interno di questo club del sesso. Per visualizzare il messaggio di <strong>$angel$</strong> ed accettare le regole del club clicca su continua.',
      'pulsante':'Continua'
    },
    'landingAutosignup':{
      'titolone': 'IMPORTANTE',
      'testo':'Ricorda che tu e gli altri membri di questo club cercate divertimento, non una relazione. Molte sono sposate e infelici, altre sono ragazze madri. Vivono tutti nella tua comunità se incontri uno o più di loro ti chiediamo di mantenere segreta la loro identità all\'interno di questo sex club. Secontinui accetti le regole del club, scegli la regione e fai clic su continua.',
      'pulsante':'Continua'
    },
    'telegramPush':{
      'titolo':'Non perderti nessun messaggio',
      'titolo_nome':'$nome$ ti risponderà.',
      'sottotitolo':'Dove vuoi saperlo subito?',
      'consigliato':'Consigliato',
      'presto':'Presto',
      'push_titolo':'Notifiche sul telefono',
      'push_testo':'Un tocco, nessuna app da installare.',
      'push_attivo':'Attive. Ti avvisiamo sul telefono.',
      'push_ios':'Prima aggiungi il sito alla schermata Home.',
      'telegram_testo':'Istantaneo e discreto. Lo spegni quando vuoi.',
      'telegram_attivo':'Attivo. Ti avvisiamo qui.',
      'whatsapp_testo':'Il messaggio arriva dove già chatti.',
      'whatsapp_messaggio':'Ciao! Attiva le notifiche per $email$',
      'passo_1':'Tocca Condividi in basso su Safari',
      'passo_2':'Scegli «Aggiungi alla schermata Home»',
      'passo_3':'Apri il sito dall\'icona e torna qui',
      'push_negato':'Hai bloccato le notifiche: riattivale dalle impostazioni del browser.',
      'push_non_supportato':'Questo browser non supporta le notifiche. Aprilo da Chrome o Safari, oppure scegli Telegram.',
      'push_errore':'Non siamo riusciti ad attivarle. Riprova tra poco.',
      'fatto':'Fatto. Da ora ti avvisiamo qui.',
      'torna_chat':'Torna alla chat',
      'torna_chat_nome':'Torna alla chat con $nome$'
    },
    'cookie':{
      'disclaimer': '<p>Este sitio utiliza cookies o otras herramientas técnicas y, previo consentimiento, también cookies de perfil u otras herramientas de seguimiento, también de terceros, para enviarte publicidad personalizada y ofrecerte servicios en línea con tus preferencias, así como la supervisión del comportamiento de los visitantes. Si quieres saber más, consulta la Política de Cookies</p><p>Si cierras este banner pinchando en la «X», seguirás navegando por el sitio sin cookies ni otras herramientas de seguimiento que no sean las técnicas.</p>',
    'button':'Aceptar todas las cookies',
    'rifiuta':'Rechazar todo'
    },
    'doi_popup':{
      'complimenti':'Ben fatto!',
      'attiva_account':'Attiva il tuo account',
      'conferma':'Conferma subito l\'indirizzo',
      'indirizzo_inserito':'L\'indirizzo che hai inserito:',
      'risulta_non_valido':'risulta <strong>NON VALIDO</strong>',
      'titolo':'Il tuo profilo su $servizio$ è stato creato con successo',
      'descrizione':'Ti abbiamo inviato una email a:',
      'indirizzo_indicato':'La tua email:',
      'se_sbagliata':'Se non è corretto puoi cambiarlo nel seguente campo:',
      'cambia_mail':'Cambia indirizzo email',
      'invia':'Cambia',
      'errore_stessa_mail':'Hai inserito la stessa email che hai indicato in fase di iscrizione. Ti abbiamo già inviato un messaggio a quell\'indirizzo. Per favore controlla anche nello Spam',
      'importante':'Importante:',
      'messaggio_ok':'Abbiamo inviato un messaggio al nuovo indirizzo di posta elettronica.',
      'errore_su_cambio_email':'non è stato possibile cambiare l\'indirizzo email',
      'punto1':'<strong>Verifica</strong> nella <strong class="blink">cartella <blink>"Spam"</blink></strong> per assicurarti che la nostra mail non sia finita lì',
      'punto2':'La nostra mail potrebbe tardare fino a 5 minuti per essere consegnata al tuo indirizzo.',
      'punto3':'Contrassegna il nostro messaggio come <strong>"NON SPAM"</strong> per assicurarti di ricevere tutti i messaggi delle donne su $servizio$'
  
    },
    'find':{
      'donne_disponibili':'Donne disponibili nella zona:'
    },
    'tooltip':{
      'titolo_attiva_notifiche':'💡 Attiva le notifiche',
      'attiva_notifiche':'Non perdere l\'occasione di incontrare le donne che ti scrivono o che visitano il tuo profilo. Attiva subito le notifiche, avrai il 90% in più di possibilità di fare centro! 🎯',
      'bottone_attiva_notifiche':'Attiva subito!'
    },
    'unsubscribe':{
      'titolo':'Disiscrizione dalla Newsletter',
      'sottotitolo':'Ci dispiace sapere che desideri disiscriverti dalla nostra newsletter. Clicca sul pulsante qui sotto per confermare la tua disiscrizione. Se cambi idea, puoi sempre iscriverti di nuovo in futuro!',
      'testo_bottone':'Disiscriviti',
      'testo_popup':'<strong>Disiscrizione avvenuta con successo!</strong><br> Verrai rediretto alla home page del sito'
    },
    'match':{
      'manda_invito':'Manda un invito',
      'anni':'anni',
      'su_di_me':'Su di me'
    },
    'recensioni':{
      'cosa_dicono':'<strong>Cosa dicono </strong>gli utenti sul web'
    }
  }
